export default __webpack_public_path__ + "static/media/antoine-dautry-_zsL306fDck-unsplash.5630caea.jpg";